import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ReturnUrlService {
  private readonly RETURN_URL_KEY = 'returnUrl';

  public setReturnUrl(url: string): void {
    // Don't store login or callback URLs as return URLs
    if (url && !url.includes('/auth/login') && !url.includes('/auth/callback') && url !== '/') {
      localStorage.setItem(this.RETURN_URL_KEY, url);
    }
  }

  public getReturnUrl(): string | null {
    return localStorage.getItem(this.RETURN_URL_KEY);
  }

  public clearReturnUrl(): void {
    localStorage.removeItem(this.RETURN_URL_KEY);
  }

  public getReturnUrlOrDefault(defaultUrl = '/'): string {
    const returnUrl = this.getReturnUrl();
    this.clearReturnUrl(); // Clear it after getting it
    return returnUrl || defaultUrl;
  }
}
